import { CORE, gateway } from '../../api';

export function buscarPreferenciaInspecaoService() {
  return gateway.get(`${CORE}/preferencia-inspecao`);
}
